import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {TestExecution, TestExecutions} from '../../../data/models/execution/test-execution';
import {TelegramDetectorService} from '../../telegram-detector.service';

@Injectable({
  providedIn: 'root'
})
export class TestExecutionService {

  constructor(
    private http: HttpClient,
    private telegramDetectorService: TelegramDetectorService,
  ) {
  }

  getTestExecutions(
    requestParam: { urlCode?: string, testId?: number, },
  ): Promise<TestExecutions> {

    let httpParams = new HttpParams();
    if (requestParam.urlCode) {
      httpParams = httpParams.set('urlCode', requestParam.urlCode);
    }
    if (requestParam.testId) {
      httpParams = httpParams.set('testId', requestParam.testId.toString());
    }

    return this.http.get<TestExecutions>(`api/test-executions`, {
      params: httpParams
    }).toPromise();
  }

  addTestExecution(
    requestParam: { urlCode?: string, testId?: number, },
    data: {
      studentName: string,
      studentMail: string,
      isTelegram?: boolean,
    }): Promise<TestExecution> {

    const formData = new FormData();
    if (requestParam.urlCode) {
      formData.append('urlCode', requestParam.urlCode);
    }
    if (requestParam.testId) {
      formData.append('testId', requestParam.testId.toString());
    }
    formData.append('studentName', data.studentName);
    formData.append('studentMail', data.studentMail);
    if (typeof data.isTelegram === 'boolean') {
      formData.append('isTelegram', data.isTelegram ? 'true' : 'false');
    }

    const telegramTagValue = this.telegramDetectorService.getInAppBrowserTagValue();
    if (telegramTagValue) {
      formData.append(this.telegramDetectorService.getInAppBrowserTagName(), telegramTagValue);
    }

    const telegramHeader = this.telegramDetectorService.getInAppBrowserHeader();
    const requestOptions: { headers?: HttpHeaders } = {};
    if (telegramHeader) {
      requestOptions.headers = new HttpHeaders().set(telegramHeader.name, telegramHeader.value);
    }

    return this.http.post<TestExecution>(`api/test-executions`, formData, requestOptions)
      .toPromise();
  }

  finishTestExecution(
    executionId: number,
  ): Promise<TestExecution> {
    return this.http.post<TestExecution>(`api/test-executions/${executionId}/actions/finish`, new FormData())
      .toPromise();
  }

}
